import { useContext } from 'react';
import { useLingui } from '@lingui/react';
import { Box, Space, Menu, ActionIcon } from '@mantine/core';
import { IconDots, IconExternalLink } from '@tabler/icons';
import { EventContext } from '../../Service/Context/EventContext';
import { EventParticipationsContext } from '../../Service/Context/EventParticipationContextV2';
import { ToastS } from '../../Service/ToastS';
import ContactListItemDescription from './ContactListItemDescription';
import GrayBox from '../../Atoms/GrayBox';
import BookitupBadge from '../../Atoms/BookitupBadge';
import { useNavigate } from 'react-router-dom';
import LinkText from '../../Atoms/LinkText';

const ContactListItem = ({
  participation,
  lastModified,
  setDeleteContact,
  setEditContact,
  index,
  setEditingContact,
  editingContact,
}) => {
  const { i18n } = useLingui();
  const { event } = useContext(EventContext);
  const navigate = useNavigate();
  const { participations, saveParticipant } = useContext(EventParticipationsContext);
  const { contactId, eventRole } = participation;

  function persistEventRole(selectedEventRole) {
    if (participations.length === 1) {
      ToastS.warn('persist.event.role', 'Es muss einen Kontakt als Hauptkunden geben.');
    } else {
      saveParticipant(contactId, selectedEventRole);
    }
  }

  const onRemove = () => {
    setDeleteContact({
      contactId,
      eventId: event.id,
      eventRole,
      index,
    });
  };

  const onEdit = () => {
    setEditContact({ index, contactId, eventRole });
    setEditingContact(true);
  };

  return (
    <GrayBox>
      <Menu withArrow shadow="md" width={200} position="bottom-end" transition="scale-y">
        <Menu.Target>
          <Box sx={{ position: 'absolute', right: 10, top: 15, cursor: 'pointer' }}>
            <ActionIcon size="xs">
              <IconDots />
            </ActionIcon>
          </Box>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item onClick={onEdit}>Bearbeiten</Menu.Item>
          <Menu.Item disabled={eventRole === 'MAIN_CUSTOMER'} onClick={onRemove}>
            Entfernen
          </Menu.Item>
          {(!eventRole || eventRole !== 'MAIN_CUSTOMER') && (
            <Menu.Item onClick={() => persistEventRole('MAIN_CUSTOMER')}>als Hauptkunden setzen</Menu.Item>
          )}
        </Menu.Dropdown>
      </Menu>
      {eventRole && participations.length > 1 && (
        <BookitupBadge title={i18n._(`eventrole.${eventRole.toLowerCase()}`)} />
      )}
      <Space h="xs" />
      <ContactListItemDescription
        lastModified={lastModified}
        contactId={contactId}
        editingContact={editingContact}
        onEdit={() => {
          setEditContact({
            index,
            contactId,
            eventRole,
          });
          setEditingContact(true);
        }}
      />
      <LinkText mt="md" size="xs" onClick={() => navigate(`/contacts/${contactId}/details`)}>
        <IconExternalLink size={16} style={{ marginRight: 5, marginBottom: 4 }} />
        Details anzeigen
      </LinkText>
    </GrayBox>
  );
};

export default ContactListItem;
